import { serviceHost } from "../../common/const";
import ServiceRequest from "../../utils/service-request";

export const getContacts = async (value) => {
  try {
    let response = await ServiceRequest(
      "get",
      "json",
      serviceHost + "/customer-supplier/getUser/" + value
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const saveData = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/customer-supplier/saveChange/",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
